module.exports = __webpack_public_path__ + "img/3d8ea45.png";